import { QueryCache, QueryClient } from "@tanstack/react-query";
import { isUnauthenticated } from "./queries";

/**
 * The one cache the app reads the server through.
 *
 * `staleTime` of 30s is the compromise the product asks for: money and rankings
 * must not be stale for long, and a screen that refetches on every mount would
 * make the single-mount feel (PRD FR-1.2) into a load spinner every time
 * somebody stepped between rooms.
 *
 * A lost session is handled HERE and nowhere else. Every read can meet a 401 —
 * a tab left open overnight meets it on whichever screen it happens to be on —
 * and answering that per-screen was how the old shell ended up threading an
 * `onSessionExpired` callback through five components.
 */
export function createQueryClient(onSessionExpired?: () => void): QueryClient {
  return new QueryClient({
    queryCache: new QueryCache({
      onError: (error) => {
        if (onSessionExpired && isUnauthenticated(error)) onSessionExpired();
      },
    }),
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        // Once. A second attempt covers a dropped connection; a third only
        // makes a screen that is going to fail take three times as long to say so.
        retry: 1,
        refetchOnWindowFocus: true,
      },
    },
  });
}
